import { ui } from 'modules/common';
import { useCallback, useMemo } from 'react';

import { SelectMonthProps } from './SelectMonth.types';

export const useSelectMonth = (month: SelectMonthProps['month'], onChange: SelectMonthProps['onChange']) => {
    const value = useMemo(
        () => ui.allMonthReferences.find((option) => Number(option.id) === Number(month))?.id,
        [month]
    );

    const handleChange = useCallback(
        (valueNext: number | string) => {
            onChange(Number(valueNext), ui.allMonthReferences);
        },
        [onChange]
    );

    return {
        value,
        handleChange,
    };
};
